
/** @name 渲染预览表单项协议【使用RenderItemTemplate.vue组件的根组件需要实现该协议】
 *  @author 王汝鹏
 *  @version 2019-11-30
 */
export const mixRenderItemTemplateProtocol = {
  provide() {
    return {
      render_item_template_store: this.render_item_template_store,
    }
  },
  computed: {
    /** 协议数据声明 [空实现，需要在使用的地方重写方法] ::: 
     *  @return {Object} formModels 表单填写变量
     *  @return {Object} formMap 表单项字典
     */
    render_item_template_store: {
      get() {
        return {
          formModels: {},
          formMap: {},
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/render_item/mix_render_item_template_protocol.js